application.register("lib-form-success", class extends Stimulus.Controller {
    connect() {
        window.gtag && window.gtag('event', 'form_submit_custom', {
            form_id: this.element.closest('form').id,
            formSubmissionId: `${this.element.closest('form').id}-${Date.now()}`
        })
    }
});
